import React, { useCallback, useMemo, useState } from "react";
// MUI Imports
import Grid from "@mui/material/Grid";
// Others
import History from "./history";
import DetailedHistory from "./detailedHistory";
import FileHistory from "./fileHistory";
import { useSelector } from "react-redux";
import { setPrevState } from "../../../../../../../util/common";
import WorkspaceService from "../../../../../../../service/workspace";
import { useParams } from "react-router-dom";
import ErrorRecords from "./ErrorRecords";

const resetState = {
  openJobHistory: false,
  openFileHistory: false,
  openErrorRecords: false,
  jobHistory_id: null,
  dateRange: null,
  selection: false,
  fileList: [],
  errorDataLoading: false,
  errorRecords: {},
  hideErrRecords: false,
};

const JobHistory = () => {
  const [historyDetails, setHistoryDetails] = useState(resetState);
  const { Workspace_id } = useParams();

  const dataPipeline = useSelector((state) => state.dataPipeline);
  const { editJob } = useMemo(() => dataPipeline, [dataPipeline]);

  const { jobId } = useMemo(() => {
    return { jobId: Number(editJob?.id || -1) };
  }, [editJob?.id]);

  const resetHistoryDetails = () => setHistoryDetails(resetState);

  const getErroredRecordsList = useCallback(
    async (jobHistory_id, sourceId, fileLocation) => {
      setPrevState(setHistoryDetails, { errorDataLoading: true, openFileHistory: false, openErrorRecords: true });

      const wsService = new WorkspaceService();
      let { data, success } = await wsService.getErroredRecordsList(
        Workspace_id,
        jobId,
        jobHistory_id,
        sourceId,
        fileLocation
      );
      if (!success) data = {};
      setPrevState(setHistoryDetails, {
        errorRecords: data,
        errorDataLoading: false,
        openFileHistory: false,
        openErrorRecords: true,
      });
    },
    [Workspace_id, jobId]
  );

  const handleBackclick = useCallback(() => {
    setPrevState(setHistoryDetails, { openErrorRecords: false, openFileHistory: true });
  }, []);

  return (
    <Grid container>
      <Grid
        pr={{ lg: 2 }}
        size={{
          xs: 12,
          lg: 5
        }}>
        <History
          setHistoryDetails={setHistoryDetails}
          selection={historyDetails.selection}
          resetHistoryDetails={resetHistoryDetails}
          resetState={resetState}
        />
      </Grid>
      {historyDetails.openJobHistory && (
        <Grid
          pl={{ lg: 2 }}
          mt={{ xs: 2, lg: 0 }}
          size={{
            xs: 12,
            lg: 7
          }}>
          <DetailedHistory historyDetails={historyDetails} />
        </Grid>
      )}
      {historyDetails.openFileHistory && (
        <Grid
          pl={{ lg: 2 }}
          mt={{ xs: 2, lg: 0 }}
          size={{
            xs: 12,
            lg: 7
          }}>
          <FileHistory
            fileList={historyDetails.fileList}
            loadErroredData={getErroredRecordsList}
            jobHistory_id={historyDetails.jobHistory_id}
            hideErrRecords={historyDetails?.hideErrRecords}
          />
        </Grid>
      )}
      {historyDetails.openErrorRecords && (
        <Grid
          pl={{ lg: 2 }}
          mt={{ xs: 2, lg: 0 }}
          size={{
            xs: 12,
            lg: 7
          }}>
          <ErrorRecords
            data={historyDetails.errorRecords}
            loading={historyDetails.errorDataLoading}
            handleBackclick={handleBackclick}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default React.memo(JobHistory);
